import { AmountForm } from 'front-office/components/amount/form';

interface RequestAmount {
  key: {
    codiceEnte?: string;
    codiceImportoPagamento?: string;
  };
  dataFineValidita?: string;
  dataInizioValidita?: string;
  descrizioneImportoPagamento?: string;
  importoPagamento?: number;
}

export const transformerDatasetAmount = (data: AmountForm): RequestAmount => {
  return {
    key: {
      codiceEnte: data.codeAgency || undefined,
      codiceImportoPagamento: data.code || undefined,
    },
    dataInizioValidita: data.dateFrom ? data.dateFrom.toFormat('yyyy-MM-dd') : undefined,
    dataFineValidita: data.dateTo ? data.dateTo.toFormat('yyyy-MM-dd') : undefined,
    descrizioneImportoPagamento: data.description || undefined,
    importoPagamento: data.amount || undefined,
  };
};
